import { type Cell } from "@tanstack/react-table";

import { type BaseObject } from "../../../../evidence/base";
import { DataTableBodyCell } from "./data-table-body-cell";

export function DataTableSelectCell<TData extends BaseObject>({
  cell,
}: {
  cell: Cell<TData, any>;
}) {
  return (
    <DataTableBodyCell
      cell={cell}
      onClick={(e) => {
        if (cell.column.id === "select") {
          e.stopPropagation();
        }
      }}
    />
  );
}
